import { ComponentType } from 'react';
import { IconError, IconWarning } from '@screentone/core';

type TokenState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: ComponentType<any> | null;
  color: string;
  tooltipText: string;
};

export const MAX_ITEMS = 100;
export const WARNING_THRESHOLD = 80;
export const QUERY_FETCH_COUNT = 10;

export const getTokenState = (length: number): TokenState => {
  if (length > MAX_ITEMS) {
    return {
      icon: IconError,
      color: 'lava',
      tooltipText: `The collection has exceeded the maximum allowed number of items (${MAX_ITEMS})`
    };
  }
  if (length >= WARNING_THRESHOLD) {
    return {
      icon: IconWarning,
      color: 'sunshine',
      tooltipText: `The maximum allowed number of items is ${MAX_ITEMS}`
    };
  }
  return {
    icon: null,
    color: 'gray',
    tooltipText: ''
  };
};

export const formatNumItemsText = (count: number) => {
  if (count >= WARNING_THRESHOLD) return `${count}/${MAX_ITEMS}`;
  return count.toString();
};
